
const useConfirmModal = () => {
  return {

    container: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 500,
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: 2,
      p: "2rem 0px 0px 0px",
      textAlign: 'center',
    },
    closeIcon: {
      position: 'absolute',
      top: 8,
      right: 8,
      color: '#6E7E91',
    },
    btnContainer: {
      display: 'flex',
      position: 'relative',
      height: '48px',
      borderTop: '1px solid #E0E0E0'
    },
    cancelBtn: {
      flex: 1,
      color: '#FF0000',
      textTransform: 'none',
      fontWeight: 600,
      height: '100%',
      borderRight: '1px solid #E0E0E0',
      '&:hover': {
        backgroundColor: '#FFEBEB',
      },
    },
    confirmBtn: {
      flex: 1,
      color: '#007BFF',
      textTransform: 'none',
      fontWeight: 600,
      height: '100%',
      '&:hover': {
        backgroundColor: '#E6F4FF',
      },
    },
    description: {
      color: '#6E7E91',
      mb: 4
    },
    icon: {
      fontSize: "1.2rem",
      mr: 1
    },
    button: {
      backgroundColor: "#EC6666",
      padding: "1rem 1.5rem",
    }
  }
}

export { useConfirmModal }
